export const userTypeMap = {
  1: {
    nodeExecUsersName: 'person'
  },
  2: {
    nodeExecUsersName: 'department'
  },
  3: {
    nodeExecUsersName: 'role'
  },
  4: {
    nodeExecUsersName: 'bmDirector'
  },
  5: {
    nodeExecUsersName: 'zsDirector'
  }
};
